// src/components/VerifyEmail.jsx
import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { auth, db } from "./firebase";
import { useLocation, useNavigate } from "react-router-dom";
import { doc, updateDoc, serverTimestamp } from "firebase/firestore";

import { resendVerifyEmail } from "../lib/emailPasswordAuth";

export default function VerifyEmail() {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const { state } = useLocation();
  const navigate = useNavigate();

  const email = state?.email || auth.currentUser?.email;

  const resend = async () => {
    setError("");
    try {
      await resendVerifyEmail();
      setSent(true);
    } catch (e) {
      setError(e?.message || "Failed to send email. Try again later.");
    }
  };

  const refresh = async () => {
    setError("");
    const u = auth.currentUser;

    if (!u) {
      setError("Not authenticated. Please login again.");
      return;
    }

    try {
      await u.reload();

      if (!u.emailVerified) {
        setError("Email is not verified yet. Check your inbox (Spam/Promotions).");
        return;
      }

      // форсим новый токен чтобы email_verified стало true в Rules
      await u.getIdToken(true);

      // отметим в users/{uid} (не обязательно, но удобно)
      await updateDoc(doc(db, "users", u.uid), {
        verified: true,
        updatedAt: serverTimestamp()
      }).catch(() => {});

      const next = (state && state.next) || "/market";
      navigate(next, { replace: true });
    } catch (e) {
      console.error(e);
      setError("Failed to refresh. Try again.");
    }
  };

  return (
    <Box sx={{ maxWidth: 520, mx: "auto", mt: 8, p: 3, color: "#e5e7eb" }}>
      <Typography variant="h5" sx={{ mb: 1, fontWeight: 900 }}>
        Confirm your email
      </Typography>

      <Typography sx={{ mb: 2, opacity: 0.85 }}>
        We sent a verification link to <b>{email || "your email"}</b>. Open it, then come back here and press Refresh.
      </Typography>

      {error && (
        <Typography color="error" sx={{ mb: 1 }}>
          {error}
        </Typography>
      )}

      {sent && (
        <Typography sx={{ mb: 1, color: "#34d399" }}>
          Email sent.
        </Typography>
      )}

      <Button variant="contained" onClick={resend} sx={{ mr: 1, fontWeight: 900 }}>
        Resend email
      </Button>

      <Button onClick={refresh} sx={{ fontWeight: 900, color: "#e5e7eb" }}>
        I verified — Refresh
      </Button>
    </Box>
  );
}


